import axios from 'axios';
import Constants from '../Constants';

const BASE_URL = `${Constants.URL}file-upload`;

export async function uploadFileToS3Request(fileData) {
  console.log(fileData)
  // const formData = new FormData();
  // formData.append('file', fileData.file);

  // // Only append file_name if explicitly provided
  // if (fileData.file_name) {
  //   formData.append('file_name', fileData.file_name);
  // }
  const fileName = fileData.file.name;
  const fileType = fileData.file.type;
  const formData = new FormData();
  formData.append('file', fileData.file);
  formData.append('file_name', fileName);
  // formData.append('Content-Type', fileType);

  console.log("uploadFileToS3Request" )
  console.log("formData", formData)
  try {
    const response = await axios.post(BASE_URL, formData, {
      headers: {
        'Content-Type': fileType,
      },
      // Critical: Prevent Axios from setting Content-Type with boundary incorrectly
      transformRequest: [data => data],
      // Optional: track upload progress
      // onUploadProgress: progressEvent => { ... }
    });

    return response.data;
  } catch (error) {
    // Re-throw with clean error for handleErrors to catch
    throw error; // Let handleErrors deal with it
  }
}
